/**
 * FeatureHelpPanel — the floating "How to use" popover anchored bottom-right
 * of the window. Extracted from FeatureManagerWindow; content unchanged.
 */
import React from 'react';
import {
  COLORS,
  SPACE,
  RADII,
  FONT_SIZE,
  FONT_WEIGHT,
  panelSurface,
} from '../../theme';

const panelStyle: React.CSSProperties = {
  ...panelSurface(),
  position: 'absolute',
  bottom: 70,
  right: SPACE.xxl,
  width: 300,
  padding: SPACE.xl,
  borderRadius: RADII.lg,
  background: COLORS.surfaceRaised,
  fontSize: FONT_SIZE.md,
  color: COLORS.textSecondary,
  lineHeight: 1.6,
};

const titleStyle: React.CSSProperties = {
  fontSize: FONT_SIZE.lg,
  fontWeight: FONT_WEIGHT.semibold,
  color: COLORS.textPrimary,
  marginBottom: SPACE.md,
  display: 'flex',
  alignItems: 'center',
  gap: SPACE.md,
};

const rowStyle: React.CSSProperties = { marginTop: SPACE.md };

export const FeatureHelpPanel: React.FC = () => {
  return (
    <div style={panelStyle}>
      <div style={titleStyle}>
        <span>❓</span>
        How to use Feature Manager
      </div>
      <div>
        <strong>Normal Mode:</strong> All enabled features are visible. Toggle switches to
        enable/disable.
      </div>
      <div style={rowStyle}>
        <strong>Whitelist Mode:</strong> Only ★ starred features are visible. Click the star to
        add/remove from whitelist.
      </div>
      <div style={rowStyle}>
        <strong>Solo Button:</strong> Isolate a single feature for testing.
      </div>
      <div style={rowStyle}>
        <strong>Console:</strong> Access <code>featureFlags</code> in browser console for scripting.
      </div>
    </div>
  );
};
